export const categories = [
  'FAQ',
  'Começando',
  'Suporte técnico',
  'Gerenciamento de contas',
  'Faturamento e Pagamentos',
  'Outros Assuntos'
];